<template>
  <div>
    <div class="container">
      <loading :active.sync="isLoading" :is-full-page="true" color="#4e97b2"></loading>
      <div class="row">
        <div class="col-lg-12 breadcrumbSection">
          <BreadcrumbsHelper :breadcrumbs="this.Breadcrumbs" />
        </div>
      </div>
      <b-card>
        <div class="row">
          <div class="col-lg-6 text-left">
            <h1 class="alertTitle">{{ alert.currentTitle }}</h1>
          </div>
          <div v-if="context === 'edit'" class="col-lg-6 text-right">
            <b-button id="duplicateAlertBtn" class="btn btn-secondary" variant="outline-primary" @click="saveAlert($event)"
              ><font-awesome-icon :icon="['far', 'copy']" size="1x" class="mr-1 fa-copy" />Duplicate</b-button
            >
            <button @click="deleteAlert()" class="btn btn-white delete-alert">Delete</button>
          </div>
          <!--end right col -->
        </div>
        <div class="row">
          <div class="col-lg-12 text-left">
            <div class="row">
              <div class="col-lg-6">
                <b-form-group label="Alert Title (Required)" label-for="title" class="alertField">
                  <b-form-input v-model="alert.title" id="title" name="title" @input="dirty = true" :state="submitted && $v.alert.title.$error ? false : null" />
                  <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.alert.title.required">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a title
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.alert.title.$invalid && context === 'edit'">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a title
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback class="d-block red" v-if="submitted && !isFirstLetterUppercase">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Title must be uppercase
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback class="d-block red" v-if="!submitted && !isFirstLetterUppercase && context === 'edit'">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Title must be uppercase
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Alert URL (Required)" label-for="url" class="alertField">
                  <b-form-input v-model="alert.url" id="url" name="url" @input="dirty = true" :state="submitted && $v.alert.url.$error ? false : null" />
                  <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.alert.url.required">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a URL
                  </b-form-invalid-feedback>
                  <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.alert.url.$invalid && context === 'edit'">
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter a URL
                  </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="Sites (required)" label-for="sites" class="alertField">
                  <b-form-checkbox inline v-model="alert.sites.app">app</b-form-checkbox>
                  <b-form-checkbox inline v-model="alert.sites.travel">travel</b-form-checkbox>
                  <b-form-checkbox inline v-model="alert.sites.partners">partners</b-form-checkbox>
                  <b-form-invalid-feedback
                    class="d-block red"
                    v-if="alert.sites.app === false && alert.sites.travel === false && alert.sites.partners === false && context === 'edit'"
                  >
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please select at least one
                    site</b-form-invalid-feedback
                  >
                  <b-form-invalid-feedback
                    class="d-block red"
                    v-if="submitted && alert.sites.app === false && alert.sites.travel === false && alert.sites.partners === false && context === 'create'"
                  >
                    <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please select at least one
                    site</b-form-invalid-feedback
                  >
                </b-form-group>
                <b-form-group label="Alert Level (required)" label-for="alert level" class="alertField">
                  <b-form-radio-group id="alertLevel" v-model="alert.level" :state="state" name="radio-validation">
                    <b-form-radio value="General">General</b-form-radio>
                    <b-form-radio value="High">High</b-form-radio>
                    <b-form-radio value="Crisis">Crisis</b-form-radio>
                    <b-form-radio value="State of Emergency">State of Emergency</b-form-radio>
                    <b-form-invalid-feedback :state="state">
                      <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please select at least one alert
                      level</b-form-invalid-feedback
                    >
                  </b-form-radio-group>
                </b-form-group>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <b-form-group label="Expires (Optional)" label-for="expiresDate">
                    <v-date-picker id="expiresDate" name="expiresDate" v-model="alert.expires" @input="dirty = true" />
                    <sub>Leave blank if it never expires</sub>
                  </b-form-group>
                  <div class="mt-4">
                    <b-form-group label="Set Alert to Active" label-for="alertActive">
                      <b-form-checkbox id="alertActive" name="alertActive" v-model="alert.isActive" @input="dirty = true" switch>Active</b-form-checkbox>
                    </b-form-group>
                  </div>
                </div>
              </div>
            </div>
            <!--end left col -->
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div>
              <b-form-group label="Message (Required)" label-form="message" class="text-left message">
                <froala
                  id="message"
                  name="message"
                  :tag="'textarea'"
                  :config="config"
                  v-model="alert.message"
                  rows="8"
                  max-rows="8"
                  @input="dirty = true"
                  :state="submitted && $v.alert.message.$error ? false : null"
                />
                <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.alert.message.required">
                  <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter an alert
                  description</b-form-invalid-feedback
                >
                <b-form-invalid-feedback class="d-block red" v-if="!submitted && $v.alert.message.$invalid && context === 'edit'">
                  <font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Please enter an alert
                  description</b-form-invalid-feedback
                >
              </b-form-group>
            </div>
            <div class="text-left">
              <h1>Accommodation Resources <span style="color: #8b9ca2">(for Alabama.Travel Only, Max 3)</span></h1>
              <div style="line-height: 1em">
                <sub>To show the set of accommodation resources select the item below.</sub><br />
                <sub>These global resources are available under settings</sub>
              </div>
              <b-form-checkbox class="mt-2" id="showAccommodation" name="showAccommodation" v-model="alert.showAccommodation" @input="dirty = true" switch
                >Show Accommodation Resources</b-form-checkbox
              >
            </div>
            <div class="text-left">
              <h1>Additional Resources <span style="color: #8b9ca2">(for Alabama.Travel Only, Max 3)</span></h1>
              <div id="additionalResourcesSection" class="row">
                <div class="col-lg-4" v-for="(resource, index) in alert.resources" :key="index">
                  <b-form-group label="Button Text (Optional)" label-for="resourcesButtonText" class="m-1" style="height: 100px">
                    <b-form-input
                      v-model="resource.buttonText"
                      :id="'resourcesButtonText' + index"
                      name="resourcesButtonText'"
                      @input="dirty = true"
                      @input.native="addResourceChange($event, index, (type = 'text'))"
                    />
                  </b-form-group>
                  <b-form-group label="URL (Optional)" label-for="resourcesUrl" class="m-1" style="height: 100px">
                    <b-form-input
                      v-model="resource.url"
                      :id="'resourcesUrl' + index"
                      name="resourcesUrl"
                      @input="dirty = true"
                      @input.native="addResourceChange($event, index, (type = 'url'))"
                    />
                  </b-form-group>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <b-form-invalid-feedback aria-live="polite" class="ml-3 d-block red" v-if="(submitted && $v.$invalid) || formInvalid"
                    ><font-awesome-icon icon="exclamation-circle" size="1x" style="color: red" class="mr-1 fas fa-exclamation-circle" />Double check the required fields. We don't
                    have everything <br />
                    <span class="ml-3">we need to save the record.</span></b-form-invalid-feedback
                  >
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <b-button id="saveAlertBtn" class="btn-secondary" @click="saveAlert($event)">Save</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
/* eslint-disable-next-line no-unused-vars */
import { required, requiredIf } from 'vuelidate/lib/validators';
import Loading from 'vue-loading-overlay';
import BreadcrumbsHelper from '../common/BreadcrumbsHelper.vue';

export default {
  components: {
    Loading,
    BreadcrumbsHelper,
  },
  data() {
    return {
      context: '',
      formInvalid: false,
      submitted: false,
      alert: {
        _id: null,
        title: null,
        currentTitle: null,
        sites: {
          app: false,
          travel: false,
          partners: false,
        },
        level: null,
        expires: null,
        isActive: false,
        resources: [],
        showAccommodation: false,
        url: null,
        message: null,
        isDuplicate: false,
      },
      dirty: false,
      showFAIcon: false,
      Breadcrumbs: [
        {
          text: 'Dashboard',
          active: false,
          href: '/admin',
        },
        {
          text: 'Settings',
          active: true,
        },
        {
          text: 'Alert Notifications',
          href: '/alerts',
          active: false,
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
      config: {
        key: `${process.env.VUE_APP_FROALA}`,
        heightMax: 150,
        toolbarButtons: ['bold', 'italic', 'underline', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'insertLink', '|', 'html', '|', 'undo', 'redo'],
        events: {},
      },
      customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['code-block']],
    };
  },
  props: {
    alertId: {
      type: String,
    },
  },
  validations: {
    alert: {
      title: {
        required,
      },
      message: {
        required,
      },
      url: {
        required,
      },
    },
  },
  computed: {
    isFirstLetterUppercase() {
      return Boolean(/^[A-Z]/.test(this.alert.title));
    },
    state() {
      return Boolean(this.alert.level);
    },
  },
  async created() {
    try {
      this.isLoading = true;
      this.context = this.$router.currentRoute.fullPath.split('/').pop();
      await Promise.all([this.getAlert()]);
    } catch (err) {
      // eslint-disable-next-line no-console
      console.log(err);
    } finally {
      this.isLoading = false;
      this.disableEmptyUrlResources();
      this.Breadcrumbs[2].text = this.alert.title;
    }
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    async getAlert() {
      if (this.alertId) {
        const alertResponse = await axios.get(`${process.env.VUE_APP_CRISIS_API2}/${this.alertId}`);
        this.alert = {
          _id: alertResponse.data._id,
          title: alertResponse.data.title,
          currentTitle: alertResponse.data.title,
          sites: alertResponse.data.sites,
          level: alertResponse.data.level,
          expires: alertResponse.data.expires ? new Date(alertResponse.data.expires) : '',
          isActive: alertResponse.data.isActive,
          message: alertResponse.data.message,
          resources: alertResponse.data.resources,
          showAccommodation: alertResponse.data.showAccommodation,
          url: alertResponse.data.url,
        };
      }
      this.dirty = false;

      // preset alert level to General for Create context to stop red validation error on  create alert page load.
      if (this.context === 'create') {
        this.alert.level = 'General';
      }

      while (this.alert.resources.length < 3) {
        const placeholderProp = { buttonText: '', url: '' };
        this.alert.resources.push(placeholderProp);
      }
      this.isLoading = false;
    },
    async saveAlert(event) {
      this.$v.$invalid === true ? (event.target.innerText = 'Save') : (event.target.innerText = 'Saving...');
      event.target.id === 'duplicateAlertBtn' ? (this.alert.isDuplicate = true) : (this.alert.isDuplicate = false);
      this.formInvalid = false;
      this.submitted = true;
      this.$v.$touch();

      if (this.alert.sites.app === false && this.alert.sites.travel === false && this.alert.sites.partners === false) {
        this.formInvalid = true;
        return;
      }

      if (!this.isFirstLetterUppercase) {
        this.formInvalid = true;
        return;
      }

      this.validateAdditionalResources();
      if (this.formInvalid === true || this.$v.$invalid === true) {
        event.target.innerText = 'Save';
        if (this.alert.isDuplicate === true) {
          this.$bvToast.toast("Double check the required fields. We don't have everything we need to duplicate the record.", {
            title: 'Unable to Duplicate Alert',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
        return;
      }
      const filterPopulated = this.alert.resources.filter((item) => item.buttonText !== '' && item.url !== '');
      this.alert.resources = filterPopulated;
      // edit or create?
      const url = this.alertId ? `${process.env.VUE_APP_CRISIS_API2}/${this.alertId}` : `${process.env.VUE_APP_CRISIS_API2}`;
      try {
        const response = await axios.post(url, { ...this.alert });
        if (response.data.success) {
          const self = this;
          if (this.alert.isDuplicate) {
            this.$router.push({ name: 'alert edit', params: { alertId: response.data.alertId } }, () => {
              setTimeout(() => {
                self.$bvToast.toast('Alert Duplicated', { title: 'Success', autoHideDelay: 5000, appendToast: true });
              }, 500);
            });
          } else {
            this.$router.push({ name: 'alerts list' }, () => {
              setTimeout(() => {
                self.$bvToast.toast('Alert Updated', { title: 'Success', autoHideDelay: 5000, appendToast: true });
              }, 500);
            });
          }
        } else {
          this.$bvToast.toast(`${JSON.stringify(response.data.message)}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
        }
      } catch (err) {
        this.$bvToast.toast('Something went wrong', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
    async addResourceChange(event, index, type) {
      const currentTargetId = `#${event.target.id.toString()}`;
      const selectorCurrentTarget = document.querySelector(currentTargetId);
      selectorCurrentTarget.style.borderColor = '#ced4da';
      selectorCurrentTarget.style.borderStyle = 'solid';

      let counterpartSelector;
      /* eslint no-unused-expressions: ["error", { "allowTernary": true }] */
      type === 'text' ? (counterpartSelector = document.querySelector(`#resourcesUrl${index}`)) : (counterpartSelector = document.querySelector(`#resourcesButtonText${index}`));

      if (event.target.value) {
        counterpartSelector.disabled = false;
      }
    },
    validateAdditionalResources() {
      const captionMessages = document.getElementsByClassName('caption');
      while (captionMessages[0]) {
        captionMessages[0].parentNode.removeChild(captionMessages[0]);
      }

      const sectionSelector = document.querySelector('#additionalResourcesSection');
      const inputs = sectionSelector.getElementsByTagName('input');

      /* the following iterates through each of the addional resources input fields and also evaluates the the value of their counterpart */
      Object.keys(inputs).forEach((key) => {
        Object.keys(inputs).forEach((x) => {
          if (inputs[key].id.substr(inputs[key].id.length - 1) === inputs[x].id.substr(inputs[x].id.length - 1) && key !== x) {
            if (inputs[key].value === '' && inputs[x].value !== '') {
              document.getElementById(`${inputs[key].id}`).style.borderColor = 'red';
              document.getElementById(`${inputs[key].id}`).style.borderStyle = 'dashed';
              this.formInvalid = true;
            }
          }
        });
      });
    },
    disableEmptyUrlResources() {
      const sectionSelector = document.querySelector('#additionalResourcesSection');
      const inputs = sectionSelector.getElementsByTagName('input');

      Object.keys(inputs).forEach((key) => {
        if (inputs[key].id.substr(0, inputs[key].id.length - 1) === 'resourcesUrl' && inputs[key].value === '') {
          document.getElementById(`${inputs[key].id}`).disabled = true;
        }
      });
    },
    async deleteAlert() {
      const response = await axios.delete(`${process.env.VUE_APP_CRISIS_API2}/${this.alertId}`);
      this.alert = response.data;
      if (response.status === 200) {
        const self = this;
        this.$router.push('/alerts', () => {
          setTimeout(() => {
            self.$bvToast.toast('Alert Deleted', { title: 'Success', autoHideDelay: 5000, appendToast: true });
          }, 500);
        });
      } else {
        this.$bvToast.toast(JSON.parse(response.data).message, {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
  },
};
</script>

<style scoped>
.card {
  border: none;
}
.card-body h1 {
  margin: 0px !important;
  line-height: 4rem;
}
.delete-alert {
  margin-left: 15px;
}
.alertField {
  height: 100px;
}
.message {
  height: 300px;
}
.validation-summary {
  background-color: green;
  height: 100px;
}
</style>
